import * as service from './service'
import { HTTP_CODE } from '@/utils/request'
import { getTimesData } from './service'

export default {
  namespace: 'serviceScoreMain',
  state: {
    demoData: {}
  },
  effects: {
    * getMainData ({ payload }, { call, put }) {
      const res = yield call(service.getMainData, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    },
    * getTimesData ({ payload }, { call, put }) {
      const res = yield call(service.getTimesData, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    },
    * signIn ({ payload }, { call, put }) {
      const res = yield call(service.signIn, payload)
      if (res.data.status !== HTTP_CODE.success) {
        // throw new Error(res.data.err)
      }
      return res.data
    },
    * getStarOverview ({ payload }, { call, put }) {
      const res = yield call(service.getStarOverview, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
